// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#discussion-monitor-wrap[data-v-1fd945b4] ol{padding-left:24px!important}#discussion-monitor-wrap[data-v-1fd945b4] li,p[data-v-1fd945b4]{font-size:15px!important}#discussion-monitor-wrap[data-v-1fd945b4] li{color:rgba(0,0,0,.87);line-height:1.5!important}#discussion-monitor-wrap[data-v-1fd945b4] em,#discussion-monitor-wrap[data-v-1fd945b4] strong{color:rgba(0,0,0,.87)}#discussion-monitor-wrap[data-v-1fd945b4] p{margin:0!important;line-height:1.5!important}", ""]);
// Exports
module.exports = exports;
